const SmsFromIcon = (props) => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.7389 18.0001L11.5045 13.7299H4.3042C1.93114 13.7299 0 11.768 0 9.35709V5.0256C0 2.61473 1.93114 0.652832 4.3042 0.652832H15.6958C18.0689 0.652832 20 2.61473 20 5.0256V9.35709C20 11.3857 18.6322 13.1188 16.7389 13.5982V18.0001Z"
      fill="#FB9318"
    />
    <path
      d="M10.3675 5.16387L11.5408 3.82201C11.6544 3.69204 11.6922 3.51664 11.6382 3.37028C11.5842 3.22392 11.4479 3.1323 11.2871 3.13432L5.20194 3.20967C5.07436 3.21101 4.94713 3.27204 4.85696 3.37518C4.76678 3.47831 4.7237 3.61206 4.74012 3.73786L5.51351 9.7485C5.53433 9.90497 5.64351 10.0246 5.79497 10.0568C5.94642 10.0891 6.11374 10.0283 6.22629 9.90026L7.40696 8.54992C7.5685 8.3658 7.83124 8.32987 7.99635 8.4693C9.31351 9.57489 12.3869 11.8133 15.6007 9.26058C15.7479 9.14285 15.8167 8.95257 15.7724 8.7858C15.7281 8.61903 15.5804 8.51204 15.4038 8.51884C14.5391 8.54627 13.2942 8.28327 11.8796 7.06068L10.3717 5.75745C10.2071 5.61523 10.2052 5.34947 10.3675 5.16387Z"
      fill="white"
    />
  </svg>
);

export default SmsFromIcon;
